__turbopack_context__.v({
  "AcceptedFormats": "JEkYhG_AcceptedFormats",
  "ChooseFiles": "JEkYhG_ChooseFiles",
  "DropArea": "JEkYhG_DropArea",
  "Dropzone": "JEkYhG_Dropzone",
  "Dropzone--IsDragActive": "JEkYhG_Dropzone--IsDragActive",
  "DropzoneWrapper": "JEkYhG_DropzoneWrapper",
  "Error": "JEkYhG_Error",
  "FileExtension": "JEkYhG_FileExtension",
  "FileItem": "JEkYhG_FileItem",
  "FileList": "JEkYhG_FileList",
  "FileNameWrapper": "JEkYhG_FileNameWrapper",
  "FileSize": "JEkYhG_FileSize",
  "FileWrapper": "JEkYhG_FileWrapper",
  "HelpText": "JEkYhG_HelpText",
  "HelpTextWrapper": "JEkYhG_HelpTextWrapper",
  "IconWrapper": "JEkYhG_IconWrapper",
  "Label": "JEkYhG_Label",
  "Placeholder": "JEkYhG_Placeholder",
  "Preview": "JEkYhG_Preview",
  "RemoveButton": "JEkYhG_RemoveButton",
  "RemoveIcon": "JEkYhG_RemoveIcon",
  "UploadIcon": "JEkYhG_UploadIcon",
  "skeleton-loading": "JEkYhG_skeleton-loading",
});
